<template>
  <div v-if="showLoader" class="loadingMask">
    <span :class="{ 'loadingText': true, 'loadingTextAnimation': !disableThreeDots }" v-html="message"></span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keep: false,
      showLoader: false,
      disableThreeDots: false,
      message: "",
    };
  },
  methods: {
    show(message, disableThreeDots = false) {
      this.disableThreeDots = disableThreeDots;
      this.message = message;
      this.showLoader = true;
    },
    stopLoading() {
      this.keep = false;
      this.hide();
    },
    keepLoading(message = null) {
      if (message) this.message = message
      this.keep = true
    },
    hide(forceHide = false) {
      if (!this.keep || forceHide) {
        this.message = "";
        this.showLoader = false;
      }
    },
  },
};
</script>

<style lang="scss">
#cardDesigner {
  .loadingMask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    font-size: 2rem;
    line-height: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  .loadingTextAnimation:after {
    content: " .";
    animation: dots 1s steps(5, end) infinite;
  }

  .loadingText {
    width: 70%;
    text-align: center;
  }

  @keyframes dots {
    0%,
    20% {
      color: rgba(0, 0, 0, 0);
      text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
    }
    40% {
      color: white;
      text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
    }
    60% {
      text-shadow: 0.25em 0 0 white, 0.5em 0 0 rgba(0, 0, 0, 0);
    }
    80%,
    100% {
      text-shadow: 0.25em 0 0 white, 0.5em 0 0 white;
    }
  }
}
</style>
